import {SingleCreateDispatcher} from '../core/dispatchers'
import {ISingleCreateDispatcher} from '../core/interfaces/dispatchers'

class AppSingleCreateDispatcher extends SingleCreateDispatcher {}

export const appSingleCreateDispatcher = new AppSingleCreateDispatcher() as ISingleCreateDispatcher
